/**
 * Collapsible "manage services & packages" disclosure (Task 150-B2;
 * primary surface updated in Task 151-B). Demotes the services/packages
 * catalog lists below the primary packages-grid surface. It is a
 * disclosure wrapper — NOT a `.card` — so the wrapped catalog sections
 * (each its own card) are not nested inside another card.
 *
 * Default-open when the catalog is empty (first-run setup), otherwise
 * collapsed so the lists do not dominate the first viewport.
 */

import { useState, type ReactNode } from 'react';
import { CaretDownIcon } from '../shell/icons';

export function ManageCatalogsSection({
  defaultOpen,
  children,
}: {
  readonly defaultOpen: boolean;
  readonly children: ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="stack-sm">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 8,
          width: '100%',
          padding: '10px 14px',
          border: '1px solid var(--line)',
          borderRadius: 'var(--r-md)',
          background: 'transparent',
          cursor: 'pointer',
          color: 'inherit',
          font: 'inherit',
        }}
      >
        <span style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          <strong style={{ fontSize: 14 }}>إدارة الخدمات والباقات</strong>
          <span className="tiny" style={{ color: 'var(--muted)' }}>
            إنشاء وتعديل الخدمات والباقات
          </span>
        </span>
        <span
          aria-hidden
          style={{
            display: 'inline-flex',
            color: 'var(--muted)',
            transform: open ? 'rotate(180deg)' : undefined,
            transition: 'transform 0.15s ease',
          }}
        >
          <CaretDownIcon size={16} />
        </span>
      </button>
      {open ? <div className="stack-md">{children}</div> : null}
    </div>
  );
}
